module.exports = __webpack_public_path__ + "img/play_schwarz.e811650d.png";